import * as chains from 'viem/chains';
import { CryptoNetworkConfig } from '../core/models/app-config/network/app-config-network.model';
import useGlobalStore from '../stores/globalStore';

/**
 * Retrieves the CryptoNetworkConfig for the given networkId.
 * @param networkId - The networkId to retrieve the CryptoNetworkConfig for.
 * @returns The CryptoNetworkConfig if found, otherwise undefined.
 */
export function getAppCryptoNetworkConfig(
  networkId: number | undefined
): CryptoNetworkConfig | undefined {
  const networks = useGlobalStore.getState().cryptoNetworks;

  return networkId
    ? networks?.find((item) => item.id === networkId)
    : undefined;
}

/**
 * Gets the chain object for the given chain id.
 * @param chainId - Chain id of the target EVM chain.
 * @returns Viem's chain object.
 */

export function getChainConfig(chainId: number) {
  for (const chain of Object.values(chains)) {
    if (chain.id === chainId) {
      return chain;
    }
  }
}
